import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonArrayService {
  difficultyLevel = [
    { label: 'Beginner', value: 'BEGINNER' },
    { label: 'Intermediate', value: 'INTERMEDIATE' },
    { label: 'Pro', value: 'PRO' },
  ];
  publishedStatus = [
    { label: 'Published', value: 'PUBLISHED' },
    { label: 'Up Coming', value: 'UPCOMING' },
  ];
  testsTypes = [
    { value: 'FULL_LENGTH_MOCK', label: 'Full Length Mock' },
    { value: 'PRACTICE_MOCK', label: 'Practice Mock' },
    { value: 'MEMORY_BASED_MOCK', label: 'Memory Based Mock' },
    { value: 'PREVIOUS_YEAR_PAPER', label: 'Previous Year Paper' },
    { value: 'SUBJECT_WISE', label: 'Subject Wise ' },
    { value: 'TOPIC_WISE', label: 'Topic Wise' },
    { value: 'MODULE_A', label: 'Module A' },
    { value: 'MODULE_B', label: 'Module B' },
    { value: 'MODULE_C', label: 'Module C' },
    { value: 'MODULE_D', label: 'Module D' },
    { value: 'MODULE_E', label: 'Module E' },
    { value: 'MODULE_F', label: 'Module F' },
    { value: 'MODULE_G', label: 'Module G' },
    { value: 'PRE', label: 'Pre' },
    { value: 'MAINS', label: 'Mains' },
    { value: 'CASE_STUDY', label: 'Case Study' },
  ];
  examsType = [
    { value: 'NORMAL', label: 'Normal' },
    { value: 'SEQUENTIAL', label: 'Sequential' },
  ];
  questionType = [
    { value: 'NORMAL', label: 'Normal' },
    { value: 'PARAGRAPH', label: 'Paragraph' },
  ];
  paidOrUnpaid = [
    { value: '', label: 'All' },
    { value: 'true', label: 'Paid' },
    { value: 'false', label: 'UnPaid' },
  ];
  userStatus = [
    { label: 'Subscribed Users', value: 'subscribedUser' },
    // { label: 'LoggedIn Users', value: 'loginUser' },
  ];
  moduleList = [
    { value: 'currentAffair', label: 'Current Affair' },
    { value: 'testSery', label: 'Test Series' },
    { value: 'editorial', label: 'Editorial' },
    { value: 'plan', label: 'Plan' },
    { value: 'jobAlert', label: 'Job Alert' },
    { value: 'freeMock', label: 'Free Mock' },
  ];

  difficultyLevelObjectByValue: any = {};
  testsTypesObjectByValue: any = {};
  examTypeObjectByValue: any = {};
  questionTypeObjectByValue: any = {};
  paidOrUnpaidObjectByValue: any = {};
  publishedStatusObjectByValue: any = {};
  userStatusObjectByValue: any = {};
  moduleListObjectByValue: any = {};
  constructor() {
    this.difficultyLevel.forEach((item: any) => {
      this.difficultyLevelObjectByValue[item.value] = item;
    });
    this.testsTypes.forEach((item: any) => {
      this.testsTypesObjectByValue[item.value] = item;
    });
    this.examsType.forEach((item: any) => {
      this.examTypeObjectByValue[item.value] = item;
    });
    this.questionType.forEach((item: any) => {
      this.questionTypeObjectByValue[item.value] = item;
    });
    this.publishedStatus.forEach((item: any) => {
      this.publishedStatusObjectByValue[item.value] = item;
    });
    this.paidOrUnpaid.forEach((item: any) => {
      this.paidOrUnpaidObjectByValue[item.value] = item;
    });
    this.userStatus.forEach((item: any) => {
      this.userStatusObjectByValue[item.value] = item;
    });
    this.moduleList.forEach((item: any) => {
      this.moduleListObjectByValue[item.value] = item;
    });
  }
}
